import AdminLoginPage from './AdminLoginPage'

export default AdminLoginPage
